import React from "react";
import InventoryTable from "src/pages/warehouse-management/inventory";

export default function InventoryPage() {
  return <InventoryTable />;
}
